type ShouldShowTargetSelectorParams = {
  targetSelectorRequested: boolean;
  targetId: number | undefined;
  selectedTargetId: number | undefined;
  dismissedTargetId: number | undefined;
  hasEmptyQueryResult: boolean;
};

export function shouldShowTargetSelector({
  targetSelectorRequested,
  targetId,
  selectedTargetId,
  dismissedTargetId,
  hasEmptyQueryResult,
}: ShouldShowTargetSelectorParams): boolean {
  return (
    targetSelectorRequested ||
    (hasEmptyQueryResult && targetId !== undefined && targetId === selectedTargetId && targetId !== dismissedTargetId)
  );
}
